import Vue from 'vue';
import Router from 'vue-router';
import Vuex from 'vuex';

import { $axios } from '../util/axios';
import { createStore } from '../stores/default';
import DjangoTranslations from '../plugins/DjangoTranslations';

Vue.use(Router);
Vue.use(Vuex);
Vue.use(DjangoTranslations);

function createRouter({ url }, component) {
  const router = new Router({
    mode: 'history',
    base: '/',
    routes: [
      {
        path: url,
        component,
      },
    ],
  });
  router.afterEach(to => {
    if (typeof window === 'object') {
      window.tracking.setCustomUrl(to.fullPath);
    }
  });
  return router;
}

export async function createSingleComponentApp({
  component,
  props,
  languageCode,
  countryCode,
  baseURL,
  router: routerOptions,
  store: { modules },
}) {
  if (!component) {
    throw new Error('createSingleComponentApp: no component provided');
  }
  if (!modules) {
    throw new Error('createSingleComponentApp: no store modules provided');
  }
  if (!countryCode) {
    throw new Error('createSingleComponentApp: no countryCode provided');
  }
  if (!languageCode) {
    throw new Error('createSingleComponentApp: no languageCode provided');
  }

  // Get translations from Django (during SSR)
  let translations;
  try {
    if (typeof window !== 'object') {
      const { data: result } = await $axios({ baseURL, countryCode }).get(
        `/static/jsi18n/${languageCode.toLowerCase()}/djangojs.json`
      );
      translations = result['catalog'];
    }
  } catch (err) {
    console.error('Error getting Django translations', err);
  }

  // Init store
  const store = createStore({
    modules,
    translations,
    countryCode,
    language: languageCode,
  });

  // Client-side replace initial state with state created on server
  if (typeof window === 'object') {
    if (window.__INITIAL_STATE__) {
      store.replaceState(window.__INITIAL_STATE__);
    }
  }

  // Create router if so defined
  let router;
  if (routerOptions) {
    router = createRouter(routerOptions, component);
  }

  const app = new Vue({
    router,
    store,
    render(createElement) {
      return createElement(
        'div',
        {
          attrs: { id: 'app' },
        },
        [createElement(component, { props })]
      );
    },
  });

  return { app, router, store };
}
